import { useLocaleForControl } from "../../../../lib/locale/useLocaleForControl";
import { FileUploaderLocaleHelper } from "../../../../components/FileUploader/locale";
export var useControlLocale = function useControlLocale(isVersionGTE5_5) {
  if (isVersionGTE5_5 === void 0) {
    isVersionGTE5_5 = true;
  }
  return useLocaleForControl('FileUploader', new FileUploaderLocaleHelper(isVersionGTE5_5));
};